
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welcome",
      function () {
        return require("private-next-pages/welcome.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/welcome"])
      });
    }
  